export const CompanyInformationFieldNames = {
  CompanyName: 'companyName',
  CarrierContactName: 'carrierContactName',
  CompanyEmail: 'companyEmail',
  CompanyPhone: 'companyPhone',
  CompanyFax: 'companyFax',
  DoingBusinessAs: 'doingBusinessAs',
} as const;

export type CompanyInformationFields = {
  [CompanyInformationFieldNames.CompanyName]?: string;
  [CompanyInformationFieldNames.CarrierContactName]?: string;
  [CompanyInformationFieldNames.CompanyEmail]?: string;
  [CompanyInformationFieldNames.CompanyPhone]?: string;
  [CompanyInformationFieldNames.CompanyFax]?: string;
  [CompanyInformationFieldNames.DoingBusinessAs]?: string;
};
